import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import './DashboardStatisticsItem.css';

const DashboardStatisticsItem = (props) => {
  // 국제화 처리
  const { formatMessage } = props.intl;
  const { title, value, unitType } = props;

  let unitMessage = '';
  // unitType: 1 - 개, 2 - 명
  if (unitType === 1) {
    unitMessage = defineMessages(formatMessage({ id: 'ExamDetail_12', defaultMessage: '개' }));
  } else if (unitType === 2) {
    unitMessage = defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }));
  }

  return (
    <div className="dashboard-statistics-item">
      <div className="common-title">
        {title}
      </div>
      <div className="statistics-value">
        <span className="number">{value}</span>
        <span className="unit">{` ${unitMessage}`}</span>
      </div>
    </div>
  )
}

export default injectIntl(DashboardStatisticsItem);


// WEBPACK FOOTER //
// ./src/script/components/dashboard/DashboardStatisticsItem.js